import React, { useState } from 'react';
import { CloseIcon } from '@util/svgicon';
import AWS from 'aws-sdk';
import { updateUserAccountData } from '@services/api';
import { useSelector, useDispatch } from "react-redux";
import * as actionTypes from "@redux/actionTypes";
import { toast } from "react-toastify";
import { useAuth } from "@context";
import toastErrorMessages from "@util/toastErrorMessage";

const S3_BUCKET = 'frodobots-web/profiles';
const REGION = 'ap-southeast-1';

const myBucket = new AWS.S3({
    region: REGION,
    accessKeyId: process.env.NEXT_PUBLIC_S3_ACCESS_KEY,
    secretAccessKey: process.env.NEXT_PUBLIC_S3_SECRET_KEY,
    signatureVersion: "v4",
})

const EditPhotoModel = ({ setIsEditOpen }) => {

    const user = useSelector((state) => state.setUserDetails.user);
    const dispatch = useDispatch();
    const { setUserDetails } = useAuth();

    const [selectedFile, setSelectedFile] = useState(null);

    const closeEditModel = () => {
        setIsEditOpen(false)
    }

    const handleFileInput = (e) => {
        setSelectedFile(e.target.files[0]);
    }


    const uploadFile = async () => {
        if (selectedFile) {
            const filename = `${user?.id}_${Date.now()}`;

            const params = {
                Bucket: S3_BUCKET,
                Key: filename,
                Body: selectedFile,
            };

            const response = await myBucket.upload(params).promise();
            if (response?.Key) {
                const updateUserProfile = {
                    "user": { "avatar_url": response.Key }
                };
                const data = await updateUserAccountData(updateUserProfile)
                if (data && data.user.username) {
                    dispatch({
                        type: actionTypes.SET_USER,
                        payload: data.user
                    })
                    toast.success(toastErrorMessages.profileUpdateSuccess, { position: "top-right" });
                    setUserDetails(data.user)
                    setIsEditOpen(false)
                }
            }
        } else {
            toast.error(toastErrorMessages.profileNotSelected, { position: "top-right" });
        }

    }

    return (
        <div className="edit_photo-modal" >
            <div className='edit_title'>
                <p className='edit_letter'>Edit Photo</p>
                <div onClick={closeEditModel} style={{ cursor: "pointer" }}>
                    <CloseIcon />
                </div>
            </div>
            <div className='choice_pic'>
                <p className='choice_content'>Please click below to upload a photo to use as your avatar. It will replace the old one.</p>
                <div className='choice_image_browser'>
                    <label htmlFor="files" className="btn" style={{ cursor: 'pointer', color: '#000000' }} >{selectedFile ? selectedFile?.name : "Click to browse..."}</label>
                    <input type="file" id="files" style={{ display: 'none', cursor: 'pointer' }} onChange={handleFileInput} />
                </div>
                <button className='upload_btn' onClick={uploadFile}>
                    <p className='upload_letter'>Upload</p>
                </button>
            </div>
        </div>
    )
}

export default EditPhotoModel